//Imports
import React, { useContext, useEffect, useState } from "react";
import Select, { components } from 'react-select';
//Imports Contexts
import { AuthContext } from "../../../contexts/AuthContext";
import staticData from '../../../contexts/staticData.json';
//Imports Icons
import addPME from '../../../assets/icons/pmeWhite.svg';
import downArrow from '../../../assets/icons/downArrow.svg';

function ContainerSearch({ dataSearch, setDataSearch, handleSelect, handleButtonClick, dataProjects, establishmentList }) {
    const { userData } = useContext(AuthContext);
    const [filteredEstablishment, setFilteredEstablishment] = useState([]);

    useEffect(() => {
        if (userData) {
            if (userData?.permissions === 'admin' && dataSearch.holder && dataSearch.holder.id) {
                setFilteredEstablishment(establishmentList?.filter((establishment) => establishment.projectId === dataSearch.holder.id));
            } else if (userData?.dimension === 'Sostenedor' && userData.tenantId) {
                setFilteredEstablishment(establishmentList?.filter((establishment) => establishment.projectId === userData.tenantId));
            }
        }
    }, [userData, dataSearch, establishmentList])


    const isButtonDisabled = !dataSearch.establishment?.id;
    const regionData = staticData.regiones.find((region) => region.name === dataSearch?.region);
    const holders = dataProjects?.filter((project) => project.commune === dataSearch?.commune);


    return (
        <article className='container-search flex'>
            {userData?.permissions === 'admin'
                ? (<>
                    <div className='first-box flex'>
                        <article className='box-input flex'>
                            <label htmlFor='region' className='hidden-label'>Región</label>
                            <Select
                                name='region'
                                id='region'
                                options={staticData.regiones.map((region) => ({
                                    value: region.name,
                                    label: region.name
                                }))
                                    .sort((a, b) => a.label.localeCompare(b.label))
                                }
                                onChange={handleSelect}
                                value={dataSearch.region ? { value: dataSearch.region, label: dataSearch.region } : null}
                                placeholder='Seleccionar Region'
                                className='select-custom'
                                classNamePrefix='select-custom'
                                components={{ DropdownIndicator }}
                            />
                        </article>
                        <article className='box-input flex'>
                            <label htmlFor='commune' className='hidden-label'>Comuna</label>
                            <Select
                                name='commune'
                                id='commune'
                                options={regionData && regionData.communes.map((commune) => ({
                                    value: commune.name,
                                    label: commune.name
                                }))
                                    .sort((a, b) => a.label.localeCompare(b.label))}
                                onChange={handleSelect}
                                value={dataSearch.commune ? { value: dataSearch.commune, label: dataSearch.commune } : null}
                                placeholder='Seleccionar Comuna'
                                className='select-custom'
                                classNamePrefix='select-custom'
                                components={{ DropdownIndicator }}
                            />
                        </article>
                        <article className='box-input hidden'></article>
                    </div>
                    <div className='second-box flex'>
                        <article className='box-input flex'>
                            <label htmlFor='holder' className='hidden-label'>Sostenedor</label>
                            <Select
                                name='holder'
                                id='holder'
                                options={holders.map((holder) => ({
                                    value: holder.nameProject,
                                    label: holder.nameProject,
                                    id: holder.id
                                }))
                                    .sort((a, b) => a.label.localeCompare(b.label))
                                }
                                onChange={handleSelect}
                                value={dataSearch.holder && dataSearch.holder.value ? { value: dataSearch.holder.value, label: dataSearch.holder.value } : null}
                                placeholder='Seleccionar Sostenedor'
                                className='select-custom'
                                classNamePrefix='select-custom'
                                components={{ DropdownIndicator }}
                            />
                        </article>
                        <article className='box-input flex'>
                            <label htmlFor='establishment' className='hidden-label'>Establecimiento</label>
                            <Select
                                name='establishment'
                                id='establishment'
                                options={filteredEstablishment.map((establishment) => ({
                                    value: establishment.nameEstablishment,
                                    label: establishment.nameEstablishment,
                                    id: establishment.id
                                }))
                                    .sort((a, b) => a.label.localeCompare(b.label))
                                }
                                onChange={handleSelect}
                                value={dataSearch.establishment && dataSearch.establishment.value ?
                                    { value: dataSearch.establishment.value, label: dataSearch.establishment.value }
                                    : null}
                                placeholder='Seleccionar Establecimiento'
                                className='select-custom'
                                classNamePrefix='select-custom'
                                components={{ DropdownIndicator }}
                            />
                        </article>
                        <button type='button' className={`box-button active flex ${isButtonDisabled && 'disabled'}`} onClick={(e) => { e.preventDefault(); console.log('button clicked'); handleButtonClick() }} disabled={isButtonDisabled}>
                            <p>Buscar PME</p>
                            <img src={addPME} className='icon' alt='Icono para buscar pme' />
                        </button>
                    </div>
                </>
                ) : (
                    userData?.dimension === 'Sostenedor' && (
                        <div className='second-box flex'>
                            <article className='box-input flex'>
                                <label htmlFor='establishment' className='hidden-label'>Establecimientos</label>
                                <Select
                                    name='establishment'
                                    id='establishment'
                                    options={filteredEstablishment.map((establishment) => ({
                                        value: establishment.nameEstablishment,
                                        label: establishment.nameEstablishment,
                                        id: establishment.id
                                    }))
                                        .sort((a, b) => a.label.localeCompare(b.label))
                                    }
                                    onChange={handleSelect}
                                    value={dataSearch.establishment && dataSearch.establishment.value ?
                                        { value: dataSearch.establishment.value, label: dataSearch.establishment.value }
                                        : null}
                                    placeholder='Seleccionar Establecimiento'
                                    className='select-custom'
                                    classNamePrefix='select-custom'
                                    components={{ DropdownIndicator }}
                                />
                            </article>
                            <button type='button' className={`box-button active flex ${isButtonDisabled && 'disabled'}`} onClick={handleButtonClick} disabled={isButtonDisabled}>
                                <p>Buscar PME</p>
                                <img src={addPME} className='icon' alt='Icono para buscar pme' />
                            </button>
                        </div>
                    )
                )

            }

        </article>
    )
};

const DropdownIndicator = (props) => {
    return (
        <components.DropdownIndicator {...props}>
            <img src={downArrow} alt="CustomArrow" />
        </components.DropdownIndicator>
    );
};

export default ContainerSearch;